import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { DebtConsolidationScreen, TitleSection } from "../../components";

export default function DebtConsolidation() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Debt Consolidation", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/debt-consolidation-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <DebtConsolidationScreen />
    </DefaultLayout>
  );
}
